import React, { useState, useEffect } from 'react';
import { studentsAPI } from '../../services/api';
import toast from 'react-hot-toast';
import Input from '../../components/common/Input';
import axios from 'axios';

const StudentForm = ({ student, classes, onSave, onCancel }) => {
  const [tab, setTab] = useState('personal');
  const [sections, setSections] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [saving, setSaving] = useState(false);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [form, setForm] = useState({
    admission_number: '', first_name: '', last_name: '', date_of_birth: '',
    gender: 'M', blood_group: '', current_class: '', current_section: '',
    admission_date: new Date().toISOString().split('T')[0], roll_number: '', status: 'active',
    email: '', phone: '', address: '', city: '', country: '', state: '', pincode: '',
    father_name: '', father_phone: '', father_occupation: '',
    mother_name: '', mother_phone: '', mother_occupation: '',
    guardian_name: '', guardian_phone: '', guardian_relation: '',
    medical_conditions: '', allergies: '', emergency_contact: '', aadhar_no: '',
  });

useEffect(() => {
    if (!student) {
        setPhotoPreview(null);

        setForm(prev => ({
            ...prev,
            photo: null,
        }));

        return;
    }

    loadCountries();

    // Load existing student data
    setForm(prev => ({
        ...prev,
        ...student,
        photo: null, // IMPORTANT: existing photo is not a File
    }));

    // Show existing photo
    if (student.photo) {
        setPhotoPreview(
            student.photo.startsWith('http')
                ? student.photo
                : `http://localhost:8000${student.photo}`
        );
    } else {
        setPhotoPreview(null);
    }

    // Load sections for selected class
    if (student.current_class) {
        studentsAPI
            .sections({
                class_obj: student.current_class,
            })
            .then(r => {
                setSections(r.data.results || r.data);
            })
            .catch(() => {
                setSections([]);
            });
    } else {
        setSections([]);
    }
}, [student]);
   const loadCountries = async () => {
    try {
      const response = await axios.get(
        'https://countriesnow.space/api/v0.1/countries/positions'
      );

      setCountries(response.data.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const loadStates = async (country) => {
    try {
      const response = await axios.post(
        'https://countriesnow.space/api/v0.1/countries/states',
        { country }
      );

      setStates(response.data.data.states || []);
    } catch (error) {
      console.log(error);
    }
  };
  const handleClassChange = async (classId) => {
    setForm(f => ({ ...f, current_class: classId, current_section: '' }));
    if (classId) {
      try {
        const res = await studentsAPI.sections({ class_obj: classId });
        setSections(res.data.results || res.data);
      } catch { setSections([]); }
    } else setSections([]);
  };

   const handleChange = (e) => {
		const { name, value, type, files } = e.target;

		setForm(prev => ({
			...prev,
			[name]: type === 'file' ? files[0] : value
		}));
	};
    const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
        return;
    }

    setForm(prev => ({
        ...prev,
        photo: file,
    }));

    setPhotoPreview(URL.createObjectURL(file));
};
   
    const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
        const formData = new FormData();

        Object.entries(form).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                formData.append(key, value);
            }
        });

        console.log("PHOTO:", form.photo);
        console.log("IS FILE:", form.photo instanceof File);

        if (student) {
            await studentsAPI.update(student.id, formData);
            toast.success('Student updated!');
        } else {
            await studentsAPI.create(formData);
            toast.success('Student admitted successfully!');
        }

        onSave();

    } catch (err) {
        console.error("STUDENT SAVE ERROR:", err);
        console.error("SERVER RESPONSE:", err.response?.data);

        const errors = err.response?.data;

        if (errors) {
            Object.entries(errors).forEach(([key, value]) => {
                toast.error(
                    `${key}: ${Array.isArray(value) ? value[0] : value}`
                );
            });
        } else {
            toast.error('Failed to save student');
        }
    } finally {
        setSaving(false);
    }
};
  const tabs = [
    { key: 'personal', label: '👤 Personal' },
    { key: 'academic', label: '📚 Academic' },
    { key: 'contact', label: '📞 Contact' },
    { key: 'parents', label: '👨‍👩‍👦 Parents' },
    { key: 'medical', label: '🏥 Medical' },
  ];

  const F = ({ label, name, type = 'text', options, required }) => (
    <div className="mb-3">
      <label className="form-label">{label} {required && <span className="text-danger">*</span>}</label>
      {options ? (
        <select className="form-select" name={name} value={form[name] || ''} onChange={handleChange} required={required}>
          <option value="">Select {label}</option>
          {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      ) : (
        <input type={type} className="form-control" name={name} value={form[name] || ''} onChange={handleChange} required={required} />
      )}
    </div>
  );

  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex gap-2 mb-4 border-bottom pb-3 flex-wrap">
        {tabs.map(t => (
          <button key={t.key} type="button"
            className={`btn btn-sm ${tab === t.key ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => setTab(t.key)}>{t.label}
          </button>
        ))}
      </div>

      {tab === 'personal' && (
        <div className="row">
			<div className="col-md-4">
				<label className="form-label">Student Photo</label>

				{photoPreview && (
					<div className="mb-2">
						<img
							src={photoPreview}
							alt="Student"
							style={{
								width: '120px',
								height: '120px',
								objectFit: 'cover',
								borderRadius: '8px',
								border: '1px solid #ddd',
							}}
						/>
					</div>
				)}

				<input
					type="file"
					name="photo"
					className="form-control"
					accept="image/*"
					onChange={handlePhotoChange}
				/>

				{student?.photo && !form.photo && (
					<small className="text-muted">
						Existing photo will be kept if no new photo is selected.
					</small>
				)}
			</div>
          <div className="col-md-4">
            {/* <F label="Admission Number" name="admission_number" value={form.admission_number}
              onChange={handleChange} required /> */}
            <Input
              label="Admission Number"
              name="admission_number"
              value={form.admission_number}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            {/* <Input label="First Name" name="first_name" required /> */}
            <Input
              label="First Name"
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            {/* <Input label="Last Name" name="last_name" required /> */}
            <Input
              label="Last Name"
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
              required
            />

          </div>
          <div className="col-md-4">
            {/* <Input label="Date of Birth" name="date_of_birth" type="date" required /> */}
            <Input
              label="Date of Birth"
              name="date_of_birth"
              value={form.date_of_birth}
              onChange={handleChange}
               />
          </div>
          <div className="col-md-4"><F label="Gender" name="gender" options={[{ value: 'M', label: 'Male' }, { value: 'F', label: 'Female' }, { value: 'O', label: 'Other' }]} required /></div>
          <div className="col-md-4"><F label="Blood Group" name="blood_group" options={['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'].map(v => ({ value: v, label: v }))} /></div>
          <div className="col-md-4"><F label="Status" name="status" options={[{ value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }]} /></div>

          <div className="col-md-4">
            <Input
              label="Aadhaar Number"
              name="aadhar_no"
              value={form.aadhar_no || ''}
              onChange={handleChange}
            />
          </div>
        </div>
      )}

      {tab === 'academic' && (
        <div className="row">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Class <span className="text-danger">*</span></label>
              <select className="form-select" value={form.current_class || ''} onChange={(e) => handleClassChange(e.target.value)} required>
                <option value="">Select Class</option>
                {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Section</label>
              <select className="form-select" name="current_section" value={form.current_section || ''} onChange={handleChange}>
                <option value="">Select Section</option>
                {sections.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
          </div>
          <div className="col-md-4"><F label="Roll Number" name="roll_number" /></div>
          <div className="col-md-4"><F label="Admission Date" name="admission_date" type="date"  /></div>
        </div>
      )}

      {tab === 'contact' && (
        <div className="row">
          <div className="col-md-6">
            {/* <F label="Email" name="email" type="email" /> */}
            <Input
              label="email"
              name="email"
              value={form.email}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            {/* <F label="Phone" name="phone" /> */}
            <Input
              label="phone"
              name="phone"
              value={form.phone}
              onChange={handleChange}
            />
          </div>
          <div className="col-12"><div className="mb-3"><label className="form-label">Address</label><textarea className="form-control" name="address" value={form.address || ''} onChange={handleChange} rows={2} /></div></div>
          <div className="col-md-3">
            <F label="City" name="city" />
          </div>

          <div className="col-md-3">
            <label className="form-label">Country</label>

            <select
              className="form-select"
              value={form.country || ''}
              onChange={(e) => {
                const country = e.target.value;

                setForm(prev => ({
                  ...prev,
                  country,
                  state: '',
                }));

                loadStates(country);
              }}
            >
              <option value="">Select Country</option>

              {countries.map((country, index) => (
                <option key={index} value={country.name}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">State</label>

            <select
              className="form-select"
              name="state"
              value={form.state || ''}
              onChange={handleChange}
            >
              <option value="">Select State</option>

              {states.map((state, index) => (
                <option key={index} value={state.name}>
                  {state.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <F label="Pincode" name="pincode" />
          </div>
        </div>
      )}

      {tab === 'parents' && (
        <div className="row">
          <div className="col-12 mb-2"><strong>Father's Details</strong></div>
          <div className="col-md-4">
            {/* <F label="Father's Name" name="father_name" /> */}
            <Input
              label="Father name"
              name="father_name"
              value={form.father_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            {/* <F label="Father's Phone" name="father_phone" /> */}
            <Input
              label="Father's Phone"
              name="father_phone"
              value={form.father_phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            {/* <F label="Father's Occupation" name="father_occupation" /> */}
            <Input
              label="Father's Occupation"
              name="father_occupation"
              value={form.father_occupation}
              onChange={handleChange}
            />
          </div>
          <div className="col-12 mb-2 mt-2"><strong>Mother's Details</strong></div>
          <div className="col-md-4"><F label="Mother's Name" name="mother_name" /></div>
          <div className="col-md-4"><F label="Mother's Phone" name="mother_phone" /></div>
          <div className="col-md-4"><F label="Mother's Occupation" name="mother_occupation" /></div>
          <div className="col-12 mb-2 mt-2"><strong>Guardian's Details (if different)</strong></div>
          <div className="col-md-4"><F label="Guardian's Name" name="guardian_name" /></div>
          <div className="col-md-4"><F label="Guardian's Phone" name="guardian_phone" /></div>
          <div className="col-md-4"><F label="Relation" name="guardian_relation" /></div>
        </div>
      )}

      {tab === 'medical' && (
        <div className="row">
          <div className="col-12"><div className="mb-3"><label className="form-label">Medical Conditions</label><textarea className="form-control" name="medical_conditions" value={form.medical_conditions || ''} onChange={handleChange} rows={3} placeholder="Any known medical conditions..." /></div></div>
          <div className="col-12"><div className="mb-3"><label className="form-label">Allergies</label><textarea className="form-control" name="allergies" value={form.allergies || ''} onChange={handleChange} rows={2} placeholder="Known allergies..." /></div></div>
          <div className="col-md-6"><F label="Emergency Contact" name="emergency_contact" /></div>
        </div>
      )}

      <div className="d-flex gap-2 justify-content-end mt-3 pt-3 border-top">
        <button type="button" className="btn btn-outline-secondary" onClick={onCancel}>Cancel</button>
        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? <><span className="spinner-border spinner-border-sm me-1" />Saving...</> : student ? '💾 Update Student' : '➕ Admit Student'}
        </button>
      </div>
    </form>
  );
};

export default StudentForm;